@if (loading$ | async) {
<div class="g-just-flex py-20">
    <mat-spinner diameter="30"></mat-spinner>
</div>
} @else if (error$ | async) {
<div class="error-state py-20">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ error$ | async }}</p>
</div>
} @else if ((prices$ | async)?.length === 0) {
<div class="empty-state py-20">
    <mat-icon>info</mat-icon>
    <p>No pricing information available</p>
</div>
} @else {
<!-- Compact Mode: Show only totals -->
@if (compactMode) {
<div class="compact-price-display">
    @let prices = (prices$ | async);
    @if (prices && prices.length === 1) {
    <div class="single-price">
        <span class="price-label">Price:</span>
        <span class="price-value">{{ formatCurrency(prices[0].totalSellingPrice, prices[0].currency) }}</span>
        @if (prices[0].totalCostPrice !== undefined) {
        <span class="cost-value subtitle-text-color-2 small-subtitle">
            (Cost: {{ formatCurrency(prices[0].totalCostPrice, prices[0].currency) }})
        </span>
        }
    </div>
    } @else if (prices && prices.length > 1) {
    <div class="total-price">
        <span class="price-label">Total:</span>
        <span class="price-value">{{ formatCurrency(getTotalPrice(), prices[0].currency) }}</span>
    </div>
    }
</div>
} @else {
<!-- Full Mode: Show detailed breakdown -->
<div class="full-price-display">
    @for (priceInfo of (prices$ | async); track priceInfo.resourceId) {
    <mat-card class="price-card mb-20">
        <mat-card-header>
            <mat-card-title class="g-just-flex flex-between w-100">
                <span>{{ priceInfo.resourceDisplay }}</span>
                @if (priceInfo.status) {
                <div [appChips]="priceInfo.status" [fontSize]="'12px'"></div>
                }
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="price-summary g-just-flex flex-between mb-15">
                <div class="selling-price">
                    <div class="label subtitle-text-color-2 small-subtitle">Selling Price</div>
                    <div class="value">{{ formatCurrency(priceInfo.totalSellingPrice, priceInfo.currency) }}</div>
                </div>

                @if (priceInfo.totalCostPrice !== undefined) {
                <div class="cost-price">
                    <div class="label subtitle-text-color-2 small-subtitle">Cost Price</div>
                    <div class="value">{{ formatCurrency(priceInfo.totalCostPrice, priceInfo.currency) }}</div>
                </div>
                }
            </div>

            @if (showBreakdown) {
            <mat-divider></mat-divider>

            <div class="price-breakdown mt-15">
                <h4 class="breakdown-title">Selling Price Breakdown</h4>
                @if (((priceInfo?.components?.base || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Base Price:</span>
                    <span>{{ formatCurrency(priceInfo?.components?.base || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.components?.surcharge || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Surcharge:</span>
                    <span>{{ formatCurrency(priceInfo?.components?.surcharge || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.components?.tax || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Tax:</span>
                    <span>{{ formatCurrency(priceInfo?.components?.tax || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.components?.deduction || 0) > 0)) {
                <div class="breakdown-row deduction">
                    <span>Deduction:</span>
                    <span>-{{ formatCurrency(priceInfo?.components?.deduction || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.components?.discount || 0) > 0)) {
                <div class="breakdown-row discount">
                    <span>Discount:</span>
                    <span>-{{ formatCurrency(priceInfo?.components?.discount || 0, priceInfo.currency) }}</span>
                </div>
                }

                @if (priceInfo.costComponents) {
                <mat-divider class="my-10"></mat-divider>
                <h4 class="breakdown-title">Cost Price Breakdown</h4>
                @if (((priceInfo?.costComponents?.base || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Base Cost:</span>
                    <span>{{ formatCurrency(priceInfo?.costComponents?.base || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.costComponents?.surcharge || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Cost Surcharge:</span>
                    <span>{{ formatCurrency(priceInfo?.costComponents?.surcharge || 0, priceInfo.currency) }}</span>
                </div>
                }
                @if (((priceInfo?.costComponents?.tax || 0) > 0)) {
                <div class="breakdown-row">
                    <span>Cost Tax:</span>
                    <span>{{ formatCurrency(priceInfo?.costComponents?.tax || 0, priceInfo.currency) }}</span>
                </div>
                }
                }
            </div>
            }
        </mat-card-content>
    </mat-card>
    }

    @if ((prices$ | async)!.length > 1) {
    <mat-card class="total-card">
        <mat-card-content>
            <div class="g-just-flex flex-between">
                <strong>Grand Total (Selling):</strong>
                <strong>{{ formatCurrency(getTotalPrice(), (prices$ | async)![0].currency) }}</strong>
            </div>
            @if ((prices$ | async)![0].totalCostPrice !== undefined) {
            <div class="g-just-flex flex-between mt-10 subtitle-text-color-2">
                <span>Total Cost:</span>
                <span>{{ formatCurrency(getTotalCost(), (prices$ | async)![0].currency) }}</span>
            </div>
            }
        </mat-card-content>
    </mat-card>
    }
</div>
}
}